import React, {Fragment} from 'react'
import providerStore from "../../../services/providers/ProvidersStore";
import {FallbackImage} from "../../../components";
import * as ListingProps from './listing-props'
import {ProviderItem} from "../../../services/providers/ProviderItems";


export class ListingProviderAndImage extends React.Component {
  static propTypes = {
    listing: ListingProps.listing.isRequired
  };

  render() {
    const {listing} = this.props;

    const provider = providerStore.getProvider(listing.contentProvider);
    const displayProviderImages = !!(provider && provider.displaySettings.displaysImages);
    const displayImage = !!(listing.photoURLs.length && displayProviderImages);
    const primaryImageURL = displayImage ? listing.photoURLs[0] : '/images/no-photos-found.png';
    return (
      <Fragment>
        <div className="mb-4">
          <ProviderItem provider={listing.contentProvider} />
        </div>
        <div className="card p-1">
          <FallbackImage style={{width: '100%', height: 'auto'}} imageURL={primaryImageURL}
                         fallbackURL={'/images/no-photos-found.png'}/>
        </div>
      </Fragment>
    );
  }
}